import { defineMessages } from 'react-intl';

export const attachmentBlockRendererMessages = defineMessages({
  previewAria: {
    defaultMessage: 'Preview {filename}',
    id: 'GKmlYVBIEL',
    description: 'Accessible label for an image attachment preview button',
  },
});
